export const AUTH_RESET = 'AUTH_RESET';
export const GOOGLE_SIGNED_IN = 'GOOGLE_SIGNED_IN';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';

export const ENABLE_IMMERSIVE = 'ENABLE_IMMERSIVE';
export const DISABLE_IMMERSIVE = 'DISABLE_IMMERSIVE';



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/actions.ts